import 'react-sweet-progress/lib/style.css'
import './BarChart.scss'

import { Progress } from 'react-sweet-progress'

const RadialChart = ({ percent, color = '#A281E9', height = 58, width }) => (
  <div>
    <Progress
      percent={Math.min(100, percent)}
      className="barChart"
      strokeWidth={8}
      status="success"
      width={width}
      height={height}
      symbolClassName="barChartSymbol"
      theme={{
        success: {
          symbol: '',
          trailColor: 'rgb(238, 238, 238)',
          color
        }
      }}
    />
  </div>
)

export default RadialChart
